import { r, s } from '@/theme/tokens';
import { Box, MenuItem, Text } from '@/ui/primitives';
import type { MenuItemProps, SxProps, Theme } from '@/ui/primitives';
import type { ReactElement, ReactNode } from 'react';

type MenuActionRowProps = {
  label: ReactNode;
  icon?: ReactNode;
  onClick?: MenuItemProps['onClick'];
  disabled?: boolean;
  sx?: SxProps<Theme>;
};

const baseMenuActionRowSx: SxProps<Theme> = {
  px: s('lg'),
  py: s('md'),
  borderRadius: r('none'),
  display: 'flex',
  alignItems: 'center',
  gap: s('sm'),
};

const menuActionRowIconSx: SxProps<Theme> = (theme) => ({
  width: theme.app.iconSizes.md,
  height: theme.app.iconSizes.md,
  color: 'inherit',
  flexShrink: 0,
});

export const MenuActionRow = ({
  label,
  icon,
  onClick,
  disabled = false,
  sx,
}: MenuActionRowProps): ReactElement => {
  const menuItemSx = (sx ? [baseMenuActionRowSx, sx] : [baseMenuActionRowSx]) as SxProps<Theme>;

  return (
    <MenuItem onClick={onClick} disabled={disabled} sx={menuItemSx}>
      {icon ? (
        <Box component="span" sx={menuActionRowIconSx}>
          {icon}
        </Box>
      ) : null}
      {typeof label === 'string' || typeof label === 'number' ? (
        <Text role="body" component="span">
          {label}
        </Text>
      ) : (
        label
      )}
    </MenuItem>
  );
};
